// src/redux/actions/phasingActions.ts
export const SHOW_PHASING_PANEL = 'SHOW_PHASING_PANEL';
export const HIDE_PHASING_PANEL = 'HIDE_PHASING_PANEL';
export const TOGGLE_PHASING_NEW_WINDOW = 'TOGGLE_PHASING_NEW_WINDOW';
export const SET_PHASING_NEW_WINDOW = 'SET_PHASING_NEW_WINDOW';
export const SET_PHASING_TASKS = 'SET_PHASING_TASKS';

export const showPhasingPanel = (ganttDataId?: number) => ({ type: SHOW_PHASING_PANEL, ganttDataId });
export const hidePhasingPanel = () => ({ type: HIDE_PHASING_PANEL });

export const togglePhasingNewWindow = () => ({ type: TOGGLE_PHASING_NEW_WINDOW });
export const setPhasingNewWindow = (isOpen: boolean) => ({ type: SET_PHASING_NEW_WINDOW, isOpen });

// Store current Gantt tasks in Redux (phasing state)
export const setPhasingTasks = (tasks: any[]) => ({ type: SET_PHASING_TASKS, tasks });
